import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSettlementQuery } from '@syf-api-library/settlement-eligibility';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import Stack from 'syf-component-library/ui/spacing/Stack';
import Body from 'syf-component-library/ui/typography/Body';
import { formatCurrency, formatDisplayDateWithFormat } from 'syf-js-utilities/formats';
import { colors } from '../../../defaultTheme';
import { useApiConfig } from '../../../hooks/useApiConfig';
import { t } from '../../../strings/i18n';
import HandHeart from '../../atoms/HandHeart';
const getPaymentList = (paymentArrangementPlans) => {
    return paymentArrangementPlans.map((payment) => {
        const { paymentAmount, paymentDueDate } = payment;
        const formattedAmount = formatCurrency(Number(paymentAmount));
        const formattedDate = formatDisplayDateWithFormat(paymentDueDate, 'MM/dd/yyyy');
        return (_jsx(Body, { children: t('text.settlementPaymentDueBy', {
                amount: formattedAmount,
                date: formattedDate
            }) }, paymentDueDate));
    });
};
const SettlementMessageBox = () => {
    const apiConfig = useApiConfig();
    const { data: settlementEligibility } = useSettlementQuery(apiConfig);
    const paymentArrangementPlans = settlementEligibility === null || settlementEligibility === void 0 ? void 0 : settlementEligibility.paymentArrangementPlans;
    const allowedSettlementAmount = settlementEligibility === null || settlementEligibility === void 0 ? void 0 : settlementEligibility.allowedSettlementAmount;
    const settlementAmount = allowedSettlementAmount && formatCurrency(Number(allowedSettlementAmount));
    return (_jsxs(MessageBox, Object.assign({ icon: _jsx(HandHeart, { color: colors.darkWarning, height: "48px", id: "hand-heart", width: "48px" }), type: "warning" }, { children: [_jsx(Body, Object.assign({ weight: "bold" }, { children: t('text.accountIsEnrolledSettlement') })), _jsx(Stack, {}), settlementAmount ? (_jsxs(_Fragment, { children: [_jsxs(Body, { children: [t('label.settlementAmount'), ": ", settlementAmount] }), getPaymentList(paymentArrangementPlans)] })) : (_jsx(Body, { children: t('text.findOutMoreInformationSettlement') }))] })));
};
export default SettlementMessageBox;
